import Identifiers from './identifiers'
import type { ReassignTarget, IdentifierType } from './identifiers-data/identifiers-types'
import AddIdentifierForm from './add-identifier-form-old'
import AddingIdentifier from './add-identifier-form-old/adding-identifier'
import EnteringIdentifier from './add-identifier-form-old/entering-identifier/entering-identifier'
import type { IdentifierTypeInfo } from './add-identifier-form-old/entering-identifier/select-type-form'
import type { IdentifierFormat } from './add-identifier-form-old/entering-identifier/entering-form'
import type { CheckResult } from './add-identifier-form-old/entering-identifier'
import IdentifiersData, { moduleTypes } from './identifiers-data'
import IdentifiersList from './identifiers-list'

export default Identifiers

export {
  AddIdentifierForm,
  EnteringIdentifier,
  AddingIdentifier,
  IdentifiersData,
  IdentifiersList,
  moduleTypes,
}

export { AddIdentifierInFrame } from './add-identifier-in-frame'

export type { IdentifierTypeInfo, IdentifierFormat, CheckResult, ReassignTarget, IdentifierType }
